import React, { useEffect, useState } from "react";
import { Grid, Text, InlineStack, Button } from "@shopify/polaris";

import InfoCard from "../../components/Common/InfoCard";
import BundleTable from "../../components/Bundles/BundleTable";
import { GetProducts } from "../../services/product";
import useProductsStore from "../../store/product";
import {
  GetBundleInventoryOverview,
  GetBundleOverview,
  GetBundles,
} from "../../services/bundle";
import useBundlesStore from "../../store/bundle";
import { useNavigate } from "react-router-dom";
import styles from "../../styles/layouts/Bundles/Bundles.module.css";
import EmptyState from "../../components/Common/EmptyState";

export default function BundleDashboard() {
  const navigate = useNavigate();
  const { setProducts } = useProductsStore();
  const [currentPage, setCurrentPage] = useState(1);
  const { setBundles, bundles } = useBundlesStore();
  const [bundleOverview, setBundleOverview] = useState([]);
  const [inventory, setInventory] = useState([
    { label: "Low Stock", value: "-" },
    { label: "Out of stock", value: "-" },
  ]);

  const capitalizeUnderscoreString = (str) => {
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const fetchProducts = async () => {
    const { data } = await GetProducts();
    if (data?.result) {
      setProducts(data.result);
    }
  };

  const fetchBundles = async () => {
    const { data } = await GetBundles(currentPage);
    if (data?.result) {
      setBundles(data.result);
    }
  };
  const fetchBundleOverview = async () => {
    const { data } = await GetBundleOverview();
    if (data.result) {
      setBundleOverview(
        Object.entries(data.result).map(([key, value]) => {
          return {
            label: capitalizeUnderscoreString(key),
            value,
          };
        })
      );
    }
  };

  const fetchBundleInventory = async () => {
    const { data } = await GetBundleInventoryOverview();
    if (data.result) {
      setInventory(
        Object.entries(data.result).map(([key, value]) => {
          return {
            label: capitalizeUnderscoreString(key),
            value,
          };
        })
      );
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchBundles();
    fetchBundleOverview();
    fetchBundleInventory();
  }, [currentPage]);

  return (
    <>
      {!bundles.length ? (
        <EmptyState
          heading={"No Bundles found"}
          text={"Add your first bundle on Giftclub"}
          btnName={"Create bundle"}
          redirect={"/bundles/create"}
        />
      ) : (
        <>
          <Text as="h3" variant="headingSm">
            Bundle Overview
          </Text>
          <br />
          <Grid columns={{ xs: 1, sm: 1, md: 12, lg: 12, xl: 12 }} fullWidth>
            {bundleOverview.map((order) => {
              return (
                <InfoCard
                  columnSpan={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}
                  label={order.label}
                  value={order.value}
                />
              );
            })}
          </Grid>
          <br />
          {/* <Text as="h3" variant="headingSm">
            Inventory Overview
          </Text> */}
          {/* <br /> */}
          {/* <Grid columns={{ xs: 1, sm: 1, md: 12, lg: 12, xl: 12 }} fullWidth>
            {inventory.map((order) => {
              return (
                <InfoCard
                  columnSpan={{ xs: 4, sm: 4, md: 4, lg: 6, xl: 6 }}
                  label={order.label}
                  value={order.value}
                />
              );
            })}
          </Grid> */}
          <br />
          <InlineStack align="space-between" wrap={false}>
            <InlineStack align="start" gap="10">
              <Text as="h3" variant="headingLg">
                Bundles
              </Text>
            </InlineStack>
            <div className={styles["flex-space"]}>
              <Button
                variant="primary"
                onClick={() => navigate("/bundles/create")}
              >
                Add new Bundle +
              </Button>
              {/* <Button variant="secondary">Export CSV</Button> */}
              {/* <Search /> */}
            </div>
          </InlineStack>
          <br />
          <BundleTable
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            fetchBundles={fetchBundles}
            fetchBundleOverview={fetchBundleOverview}
            bundles={bundles}
          />
          <br />
        </>
      )}
    </>
  );
}
